import React from 'react';
import { TrendingUpIcon, UsersIcon, ArrowRightIcon, ZapIcon, CheckCircleIcon, CalendarIcon, AlertCircleIcon, MegaphoneIcon, InfoIcon, BuildingIcon, CloudIcon, UserCogIcon, BarChart2Icon, FolderIcon, ShieldCheckIcon } from 'lucide-react';
const kpis = [{
  label: 'Loans Closed MTD',
  value: '47',
  change: '+12%',
  positive: true,
  color: '#2B8DC4'
}, {
  label: 'Pipeline Value',
  value: '$8.4M',
  change: '+5.2%',
  positive: true,
  color: '#1E6FA0'
}, {
  label: 'Team Members',
  value: '124',
  change: '+3 new',
  positive: true,
  color: '#2B8DC4'
}, {
  label: 'Avg. Close Time',
  value: '28d',
  change: '-2 days',
  positive: true,
  color: '#1E6FA0'
}];
const recentActivity = [{
  user: 'Sarah K.',
  action: 'closed a loan for $425,000',
  time: '2h ago',
  avatar: 'SK',
  color: '#2B8DC4'
}, {
  user: 'Marcus T.',
  action: 'completed Compliance Training 2025',
  time: '3h ago',
  avatar: 'MT',
  color: '#1A2B3C'
}, {
  user: 'Priya R.',
  action: 'posted in the team feed',
  time: '4h ago',
  avatar: 'PR',
  color: '#2B8DC4'
}, {
  user: 'Derek L.',
  action: 'earned "Top Originator" badge',
  time: '5h ago',
  avatar: 'DL',
  color: '#1A2B3C'
}, {
  user: 'Lisa M.',
  action: 'shared a new training video',
  time: '6h ago',
  avatar: 'LM',
  color: '#2B8DC4'
}];
const upcomingEvents = [{
  title: 'All-Hands Meeting',
  date: 'Mar 5',
  time: '10:00 AM'
}, {
  title: 'Q1 Sales Review',
  date: 'Mar 8',
  time: '2:00 PM'
}, {
  title: 'Compliance Training',
  date: 'Mar 12',
  time: '9:00 AM'
}, {
  title: 'New Product Launch',
  date: 'Mar 15',
  time: '11:00 AM'
}];
const myTasks = [{
  task: 'Review loan application #4821',
  due: 'Today',
  done: false
}, {
  task: 'Complete NMLS renewal',
  due: 'Mar 7',
  done: false
}, {
  task: 'Submit Q1 pipeline report',
  due: 'Mar 10',
  done: true
}, {
  task: 'Team 1:1 with Sarah K.',
  due: 'Mar 6',
  done: false
}];
const quickLinks = [{
  label: 'Encompass LOS',
  icon: BuildingIcon,
  color: '#2B8DC4'
}, {
  label: 'Salesforce CRM',
  icon: CloudIcon,
  color: '#1E6FA0'
}, {
  label: 'HR Portal',
  icon: UserCogIcon,
  color: '#2B8DC4'
}, {
  label: 'Rate Sheet',
  icon: BarChart2Icon,
  color: '#1E6FA0'
}, {
  label: 'Shared Drive',
  icon: FolderIcon,
  color: '#2B8DC4'
}, {
  label: 'Compliance Hub',
  icon: ShieldCheckIcon,
  color: '#1E6FA0'
}];
const announcements = [{
  type: 'urgent' as const,
  title: 'New TRID Disclosure Requirements — Effective March 15',
  body: 'All loan officers must complete the 30-minute compliance training module by March 10.',
  author: 'Jennifer Walsh · Chief Compliance Officer',
  date: 'Mar 1',
  tag: 'URGENT'
}, {
  type: 'celebration' as const,
  title: '🎉 Swift Hits $1 Billion in Annual Volume!',
  body: "We've officially crossed the $1B milestone — top 5% of independent mortgage companies nationally.",
  author: 'Robert Swift · CEO & Founder',
  date: 'Feb 28',
  tag: 'MILESTONE'
}, {
  type: 'info' as const,
  title: 'Updated Rate Sheets Now Live',
  body: 'New sheets for conventional, FHA, VA, and USDA products are in the Launchpad. Discard sheets prior to March 1.',
  author: 'Mark Chen · Secondary Markets',
  date: 'Mar 1',
  tag: 'RATES'
}, {
  type: 'update' as const,
  title: 'Q1 All-Hands — March 5 at 10 AM',
  body: 'Join via Zoom or HQ Conference Room A. Agenda: Q4 results, Q1 goals, product updates, recognition.',
  author: 'Executive Team',
  date: 'Feb 24',
  tag: 'EVENT'
}];
const announcementStyles = {
  urgent: {
    border: '#2B8DC4',
    tag: '#EF4444',
    tagBg: '#FEF2F2',
    icon: AlertCircleIcon
  },
  celebration: {
    border: '#2B8DC4',
    tag: '#D97706',
    tagBg: '#FFFBEB',
    icon: MegaphoneIcon
  },
  info: {
    border: '#2B8DC4',
    tag: '#1E6FA0',
    tagBg: '#EBF5FB',
    icon: InfoIcon
  },
  update: {
    border: '#2B8DC4',
    tag: '#1A2B3C',
    tagBg: '#F1F5F9',
    icon: CalendarIcon
  }
};
export function Dashboard() {
  return <div style={{
    maxWidth: 1280,
    margin: '0 auto'
  }} data-id="element-66">
      {/* Hero Banner */}
      <div style={{
      borderRadius: 16,
      padding: '32px 40px',
      marginBottom: 24,
      position: 'relative',
      overflow: 'hidden',
      background: 'linear-gradient(118deg, #0D1B2A 0%, #1E6FA0 45%, #0D1B2A 100%)',
      minHeight: 160
    }} data-id="element-67">
        <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'repeating-linear-gradient(-55deg, transparent, transparent 18px, rgba(255,255,255,0.025) 18px, rgba(255,255,255,0.025) 36px)',
        pointerEvents: 'none'
      }} data-id="element-68" />
        <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '40%',
        height: '100%',
        background: 'linear-gradient(118deg, transparent 0%, rgba(43,141,196,0.2) 100%)',
        clipPath: 'polygon(30% 0, 100% 0, 100% 100%, 0% 100%)',
        pointerEvents: 'none'
      }} data-id="element-69" />
        <div style={{
        position: 'absolute',
        right: 40,
        top: '50%',
        transform: 'translateY(-50%)',
        opacity: 0.07,
        pointerEvents: 'none'
      }} data-id="element-70">
          <svg width="220" height="140" viewBox="0 0 220 140" fill="none" data-id="element-71">
            <path d="M10 70 C40 20, 100 10, 210 50 C170 50, 150 65, 165 95 C130 75, 90 85, 70 120 C72 88, 50 72, 10 70Z" fill="white" data-id="element-72" />
            <path d="M80 55 C100 35, 140 30, 200 45 C175 48, 162 58, 170 75 C148 62, 118 65, 100 85 C104 65, 92 57, 80 55Z" fill="white" opacity="0.6" data-id="element-73" />
          </svg>
        </div>
        <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 4,
        background: 'linear-gradient(90deg, #2B8DC4 0%, #3FA8E0 60%, transparent 100%)'
      }} data-id="element-74" />
        <div style={{
        position: 'relative',
        zIndex: 1
      }} data-id="element-75">
          <div style={{
          fontSize: 12,
          color: 'rgba(255,255,255,0.5)',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          marginBottom: 6
        }} data-id="element-76">
            Welcome back
          </div>
          <h2 style={{
          fontSize: 32,
          fontWeight: 900,
          color: '#FFFFFF',
          margin: '0 0 6px',
          fontStyle: 'italic',
          letterSpacing: '-0.04em',
          lineHeight: 1
        }} data-id="element-77">
            Good morning, Jamie! 🏡
          </h2>
          <p style={{
          color: 'rgba(255,255,255,0.6)',
          fontSize: 14,
          margin: '0 0 16px',
          fontWeight: 500
        }} data-id="element-78">
            Here's what's happening at Swift Home Loans today.
          </p>
          <div style={{
          display: 'flex',
          gap: 10,
          flexWrap: 'wrap'
        }} data-id="element-79">
            <span style={{
            padding: '5px 14px',
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 800,
            background: '#2B8DC4',
            color: 'white',
            fontStyle: 'italic'
          }} data-id="element-80">
              🏆 Top Originator — February
            </span>
            <span style={{
            padding: '5px 14px',
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 600,
            background: 'rgba(255,255,255,0.1)',
            color: 'rgba(255,255,255,0.8)',
            border: '1px solid rgba(255,255,255,0.15)'
          }} data-id="element-81">
              47 loans closed MTD
            </span>
          </div>
        </div>
      </div>

      {/* KPI Cards */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 16,
      marginBottom: 24
    }} data-id="element-82">
        {kpis.map(kpi => <div key={kpi.label} style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '20px 22px',
        borderTop: `3px solid #2B8DC4`,
        border: '1px solid #E4EAF6',
        borderTopColor: '#2B8DC4',
        borderTopWidth: 3,
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
        position: 'relative',
        overflow: 'hidden'
      }} data-id="element-83">
            <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: 60,
          height: 60,
          background: `${kpi.color}06`,
          clipPath: 'polygon(100% 0, 100% 100%, 0 0)'
        }} data-id="element-84" />
            <div style={{
          marginBottom: 8
        }} data-id="element-85">
              <span style={{
            fontSize: 11,
            fontWeight: 700,
            color: kpi.color,
            background: `${kpi.color}12`,
            padding: '2px 8px',
            borderRadius: 4,
            fontStyle: 'italic'
          }} data-id="element-86">
                {kpi.change}
              </span>
            </div>
            <div style={{
          fontSize: 38,
          fontWeight: 900,
          color: '#1A2B3C',
          letterSpacing: '-0.04em',
          fontStyle: 'italic',
          lineHeight: 1,
          marginBottom: 8,
          position: 'relative',
          display: 'inline-block'
        }} data-id="element-87">
              {kpi.value}
              <div style={{
            position: 'absolute',
            bottom: -4,
            left: 0,
            width: '60%',
            height: 3,
            borderRadius: 2,
            background: kpi.color
          }} data-id="element-88" />
            </div>
            <div style={{
          fontSize: 12,
          color: '#5A6A8A',
          fontWeight: 600,
          marginTop: 8
        }} data-id="element-89">
              {kpi.label}
            </div>
          </div>)}
      </div>

      {/* Announcements */}
      <div style={{
      background: '#FFFFFF',
      borderRadius: 12,
      padding: '20px 24px',
      marginBottom: 20,
      boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
      border: '1px solid #E4EAF6',
      borderTop: '3px solid #2B8DC4'
    }} data-id="element-90">
        <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 16
      }} data-id="element-91">
          <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }} data-id="element-92">
            <MegaphoneIcon size={17} color="#2B8DC4" data-id="element-93" />
            <h3 style={{
            fontSize: 15,
            fontWeight: 900,
            color: '#1A2B3C',
            margin: 0,
            fontStyle: 'italic',
            letterSpacing: '-0.02em'
          }} data-id="element-94">
              Announcements
            </h3>
            <span style={{
            fontSize: 10,
            fontWeight: 800,
            padding: '2px 7px',
            borderRadius: 4,
            background: '#EBF5FB',
            color: '#2B8DC4',
            letterSpacing: '0.06em'
          }} data-id="element-95">
              4 NEW
            </span>
          </div>
        </div>
        <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: 12
      }} data-id="element-96">
          {announcements.map((ann, i) => {
          const s = announcementStyles[ann.type];
          const Icon = s.icon;
          return <div key={i} style={{
            borderRadius: 8,
            padding: '14px 16px',
            background: '#F4F8FC',
            borderLeft: `2px solid #2B8DC4`,
            display: 'flex',
            gap: 12,
            cursor: 'pointer',
            transition: 'box-shadow 0.15s',
            border: '1px solid #E4EAF6',
            borderLeftColor: '#2B8DC4',
            borderLeftWidth: 2
          }} onMouseEnter={e => {
            ;
            (e.currentTarget as HTMLDivElement).style.boxShadow = '0 2px 12px rgba(43,141,196,0.12)';
          }} onMouseLeave={e => {
            ;
            (e.currentTarget as HTMLDivElement).style.boxShadow = 'none';
          }} data-id="element-97">
                <div style={{
              flexShrink: 0,
              marginTop: 2
            }} data-id="element-98">
                  <Icon size={16} color="#2B8DC4" data-id="element-99" />
                </div>
                <div style={{
              flex: 1,
              minWidth: 0
            }} data-id="element-100">
                  <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                marginBottom: 4
              }} data-id="element-101">
                    <span style={{
                  fontSize: 10,
                  fontWeight: 800,
                  padding: '1px 6px',
                  borderRadius: 3,
                  background: s.tagBg,
                  color: s.tag,
                  letterSpacing: '0.06em'
                }} data-id="element-102">
                      {ann.tag}
                    </span>
                    <span style={{
                  fontSize: 10,
                  color: '#A0AECB'
                }} data-id="element-103">
                      {ann.date}
                    </span>
                  </div>
                  <div style={{
                fontSize: 13,
                fontWeight: 800,
                color: '#1A2B3C',
                marginBottom: 3,
                lineHeight: 1.3
              }} data-id="element-104">
                    {ann.title}
                  </div>
                  <div style={{
                fontSize: 12,
                color: '#5A6A8A',
                lineHeight: 1.5,
                marginBottom: 4
              }} data-id="element-105">
                    {ann.body}
                  </div>
                  <div style={{
                fontSize: 11,
                color: '#A0AECB',
                fontWeight: 500
              }} data-id="element-106">
                    {ann.author}
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>

      {/* Main Grid */}
      <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 340px',
      gap: 20
    }} data-id="element-107">
        {/* Left Column */}
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 20
      }} data-id="element-108">
          {/* Activity Feed */}
          <div style={{
          background: '#FFFFFF',
          borderRadius: 12,
          padding: '20px 22px',
          boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
          border: '1px solid #E4EAF6',
          borderTop: '3px solid #2B8DC4'
        }} data-id="element-109">
            <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 18
          }} data-id="element-110">
              <h3 style={{
              fontSize: 15,
              fontWeight: 900,
              color: '#1A2B3C',
              margin: 0,
              fontStyle: 'italic',
              letterSpacing: '-0.02em'
            }} data-id="element-111">
                Recent Activity
              </h3>
              <button style={{
              fontSize: 12,
              fontWeight: 700,
              color: '#2B8DC4',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
              fontStyle: 'italic'
            }} data-id="element-112">
                View all <ArrowRightIcon size={12} data-id="element-113" />
              </button>
            </div>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 14
          }} data-id="element-114">
              {recentActivity.map((item, i) => <div key={i} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12
            }} data-id="element-115">
                  <div style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                background: item.color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 11,
                fontWeight: 800,
                color: 'white',
                flexShrink: 0,
                transform: 'skewX(-4deg)'
              }} data-id="element-116">
                    {item.avatar}
                  </div>
                  <div style={{
                flex: 1
              }} data-id="element-117">
                    <p style={{
                  fontSize: 13,
                  color: '#1A2B3C',
                  margin: 0
                }} data-id="element-118">
                      <span style={{
                    fontWeight: 700
                  }} data-id="element-119">
                        {item.user}
                      </span>{' '}
                      <span style={{
                    color: '#5A6A8A'
                  }} data-id="element-120">
                        {item.action}
                      </span>
                    </p>
                    <p style={{
                  fontSize: 11,
                  color: '#A0AECB',
                  margin: '2px 0 0'
                }} data-id="element-121">
                      {item.time}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Quick Access */}
          <div style={{
          background: '#FFFFFF',
          borderRadius: 12,
          padding: '20px 22px',
          boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
          border: '1px solid #E4EAF6',
          borderTop: '3px solid #1A2B3C'
        }} data-id="element-122">
            <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginBottom: 16
          }} data-id="element-123">
              <ZapIcon size={16} color="#2B8DC4" data-id="element-124" />
              <h3 style={{
              fontSize: 15,
              fontWeight: 900,
              color: '#1A2B3C',
              margin: 0,
              fontStyle: 'italic',
              letterSpacing: '-0.02em'
            }} data-id="element-125">
                Quick Access
              </h3>
            </div>
            <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 8
          }} data-id="element-126">
              {quickLinks.map(link => {
              const Icon = link.icon;
              return <button key={link.label} style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                padding: '10px 12px',
                borderRadius: 8,
                background: '#F4F8FC',
                border: '1px solid #E4EAF6',
                cursor: 'pointer',
                transition: 'all 0.15s',
                textAlign: 'left',
                borderLeft: '3px solid transparent'
              }} onMouseEnter={e => {
                e.currentTarget.style.borderLeftColor = '#2B8DC4';
                e.currentTarget.style.background = 'rgba(43,141,196,0.05)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(43,141,196,0.1)';
              }} onMouseLeave={e => {
                e.currentTarget.style.borderLeftColor = 'transparent';
                e.currentTarget.style.background = '#F4F8FC';
                e.currentTarget.style.boxShadow = 'none';
              }} data-id="element-127">
                    <div style={{
                  width: 28,
                  height: 28,
                  borderRadius: 6,
                  background: 'rgba(43,141,196,0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }} data-id="element-128">
                      <Icon size={14} color="#2B8DC4" strokeWidth={2} data-id="element-129" />
                    </div>
                    <span style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: '#1A2B3C',
                  lineHeight: 1.2
                }} data-id="element-130">
                      {link.label}
                    </span>
                  </button>;
            })}
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }} data-id="element-131">
          {/* My Tasks */}
          <div style={{
          background: '#FFFFFF',
          borderRadius: 12,
          padding: '18px 20px',
          boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
          border: '1px solid #E4EAF6',
          borderTop: '3px solid #2B8DC4'
        }} data-id="element-132">
            <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 14
          }} data-id="element-133">
              <h3 style={{
              fontSize: 14,
              fontWeight: 900,
              color: '#1A2B3C',
              margin: 0,
              fontStyle: 'italic',
              letterSpacing: '-0.02em'
            }} data-id="element-134">
                My Tasks
              </h3>
              <span style={{
              fontSize: 11,
              fontWeight: 800,
              padding: '2px 8px',
              borderRadius: 4,
              background: '#EBF5FB',
              color: '#2B8DC4',
              fontStyle: 'italic'
            }} data-id="element-135">
                {myTasks.filter(t => !t.done).length} pending
              </span>
            </div>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10
          }} data-id="element-136">
              {myTasks.map((task, i) => <div key={i} style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10
            }} data-id="element-137">
                  <CheckCircleIcon size={16} color={task.done ? '#2B8DC4' : '#CBD5E1'} style={{
                flexShrink: 0,
                marginTop: 1
              }} data-id="element-138" />
                  <div data-id="element-139">
                    <p style={{
                  fontSize: 12,
                  color: task.done ? '#A0AECB' : '#1A2B3C',
                  margin: 0,
                  fontWeight: 600,
                  textDecoration: task.done ? 'line-through' : 'none'
                }} data-id="element-140">
                      {task.task}
                    </p>
                    <p style={{
                  fontSize: 11,
                  color: '#A0AECB',
                  margin: '2px 0 0'
                }} data-id="element-141">
                      Due: {task.due}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Upcoming Events */}
          <div style={{
          background: '#FFFFFF',
          borderRadius: 12,
          padding: '18px 20px',
          boxShadow: '0 2px 8px rgba(13,27,42,0.06)',
          border: '1px solid #E4EAF6',
          borderTop: '3px solid #1A2B3C'
        }} data-id="element-142">
            <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 14
          }} data-id="element-143">
              <h3 style={{
              fontSize: 14,
              fontWeight: 900,
              color: '#1A2B3C',
              margin: 0,
              fontStyle: 'italic',
              letterSpacing: '-0.02em'
            }} data-id="element-144">
                Upcoming
              </h3>
              <CalendarIcon size={15} color="#A0AECB" data-id="element-145" />
            </div>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10
          }} data-id="element-146">
              {upcomingEvents.map((event, i) => <div key={i} style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10
            }} data-id="element-147">
                  <div style={{
                minWidth: 44,
                padding: '5px 6px',
                borderRadius: 6,
                background: '#EBF5FB',
                textAlign: 'center',
                flexShrink: 0
              }} data-id="element-148">
                    <div style={{
                  fontSize: 11,
                  fontWeight: 900,
                  color: '#2B8DC4',
                  fontStyle: 'italic',
                  letterSpacing: '-0.02em'
                }} data-id="element-149">
                      {event.date}
                    </div>
                  </div>
                  <div data-id="element-150">
                    <p style={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: '#1A2B3C',
                  margin: 0
                }} data-id="element-151">
                      {event.title}
                    </p>
                    <p style={{
                  fontSize: 11,
                  color: '#5A6A8A',
                  margin: '1px 0 0'
                }} data-id="element-152">
                      {event.time}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Spotlight */}
          <div style={{
          borderRadius: 12,
          padding: '18px 20px',
          background: 'linear-gradient(135deg, #0D1B2A 0%, #1E6FA0 100%)',
          position: 'relative',
          overflow: 'hidden'
        }} data-id="element-153">
            <div style={{
            position: 'absolute',
            top: 0,
            right: 0,
            width: '50%',
            height: '100%',
            background: 'linear-gradient(135deg, transparent, rgba(43,141,196,0.25))',
            clipPath: 'polygon(40% 0, 100% 0, 100% 100%, 0 100%)'
          }} data-id="element-154" />
            <div style={{
            position: 'relative',
            zIndex: 1
          }} data-id="element-155">
              <div style={{
              fontSize: 10,
              fontWeight: 800,
              color: '#3FA8E0',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              marginBottom: 8
            }} data-id="element-156">
                ⚡ Spotlight
              </div>
              <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              marginBottom: 8
            }} data-id="element-157">
                <div style={{
                width: 38,
                height: 38,
                borderRadius: 10,
                background: 'linear-gradient(135deg, #2B8DC4, #0D1B2A)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 13,
                fontWeight: 800,
                color: 'white',
                transform: 'skewX(-4deg)'
              }} data-id="element-158">
                  SK
                </div>
                <div data-id="element-159">
                  <div style={{
                  fontSize: 13,
                  fontWeight: 900,
                  color: 'white',
                  fontStyle: 'italic',
                  letterSpacing: '-0.02em'
                }} data-id="element-160">
                    Sarah Kim
                  </div>
                  <div style={{
                  fontSize: 11,
                  color: 'rgba(255,255,255,0.5)'
                }} data-id="element-161">
                    Top Originator · Feb
                  </div>
                </div>
              </div>
              <p style={{
              fontSize: 12,
              color: 'rgba(255,255,255,0.65)',
              margin: 0,
              lineHeight: 1.5
            }} data-id="element-162">
                23 loans closed — a company record. Incredible work! 🏆
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}